import React, { createRef } from "react";
import classes from "./EmbedVideoPlayer.scss";
import { connect } from "react-redux";
import ReactPlayer from "react-player";
import { openLinkInNewTab } from "modules/Services";
import {
  DeleteOutlined,
  LinkOutlined,
  LinkColored,
  PlayFilled,
} from "@toddle-edu/ds-icons";
import classNames from "classnames";
import { IconButton, Tag } from "@toddle-edu/ds-web";

class EmbedVideoPlayer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showThumbnail: true,
      showPlayer: false,
      isPlayerSpace: true,
      isControlsSpace: false,
    };
    this.containerRef = createRef();
  }
  componentDidMount() {
    if (this.props.onRef) this.props.onRef(this);
    if (this.containerRef?.current) {
      this.setState({
        isControlsSpace:
          !this.state.isControlsSpace &&
          this.containerRef?.current.offsetWidth >= 400,
        isPlayerSpace: this.containerRef?.current.offsetWidth >= 300,
      });
    }
  }

  onClickActionButton = actionName => event => {
    const { url, onDeleteClick, openLinkInNewTab } = this.props;
    event.stopPropagation();
    switch (actionName) {
      case "OPEN_LINK": {
        openLinkInNewTab({ url });
        break;
      }
      case "DELETE": {
        onDeleteClick();
        break;
      }
      default:
        return;
    }
  };

  onClick = e => {
    if (this.props.onClick) this.props.onClick(e);
    if (this.state.isPlayerSpace) {
      e.stopPropagation();
      if (this.state.showThumbnail) this.setState({ showThumbnail: false });
      this.setState({ showPlayer: true });
    }
  };
  onPlay = () => {
    if (this.props.onPlay) this.props.onPlay();
    this.setState({ showPlayer: true });
  };

  play() {
    this.setState({ showPlayer: true });
  }
  pause() {
    this.setState({ showPlayer: false });
  }
  resetPlayer() {
    this.setState({ showThumbnail: true });
  }

  render() {
    const {
      itemStyle,
      showExtensionOnCornerByHover = false,
      showOverlayIcons = true,
    } = this.props;
    const onHoverIconClass = classNames(
      { [classes.middleIconContainer]: true },
      { [classes.hoverIconContainer]: true }
    );
    const renderElements = (
      <div
        onClick={this.onClick}
        ref={this.containerRef}
        className={this.props.className || classes.embedVidePlayerContainer}
      >
        {this.state.showThumbnail ? (
          <div
            style={{
              backgroundImage: "url(" + this.props.thumbnail + ")",
              backgroundSize: "cover",
              ...(itemStyle || {}),
            }}
            className={classes.overlayContainer}
          >
            {showExtensionOnCornerByHover && (
              <div className={classes.cornerTagExtensionContainer}>
                <Tag size={"x-small"} prefix={<LinkColored />}>
                  {"Link"}
                </Tag>
              </div>
            )}
            {this.state.isPlayerSpace ? (
              <div className={classes.middleIconContainer}>
                <IconButton
                  variant={"dark"}
                  size={"medium"}
                  icon={<PlayFilled variant="on" />}
                />
              </div>
            ) : showOverlayIcons ? (
              <div className={classes.embedPlayerOverlay}>
                <div
                  className={onHoverIconClass}
                  onClick={this.onClickActionButton("DELETE")}
                >
                  <DeleteOutlined variant={"on"} size={"xxx-small"} />
                </div>
                <div
                  className={classes.middleIconContainer}
                  onClick={this.onClickActionButton("OPEN_LINK")}
                >
                  <LinkOutlined variant={"on"} size={"xxx-small"} />
                </div>
              </div>
            ) : null}
          </div>
        ) : (
          this.state.isPlayerSpace && (
            <ReactPlayer
              url={this.props.url}
              playing={this.state.showPlayer}
              width={"100%"}
              height={"100%"}
              className={classes.embedVidePlayerContainer}
              controls={this.props.controls || this.state.isControlsSpace}
              onPlay={this.onPlay}
            />
          )
        )}
      </div>
    );
    return renderElements;
  }
}

const mapActionCreators = {
  openLinkInNewTab,
};

export default connect(null, mapActionCreators)(EmbedVideoPlayer);
